/*
 * LB Filtros (Lui Bambini): ajustes de texto nas opções de filtro.
 *  - Gênero vem do Google em inglês (female/male/unisex) → Menina/Menino/Unissex
 *  - Cor ganha uma bolinha com o tom pelo nome (pintada pelo lb-cores-por-nome.js)
 * Roda de novo quando o tema redesenha os filtros.
 */
(function () {
  'use strict';
  var GENERO = { female: 'Menina', male: 'Menino', unisex: 'Unissex', unissex: 'Unissex' };

  function esconder(li) { li.hidden = true; li.setAttribute('data-lb-oculto', ''); }

  function ajustar(raiz) {
    // o tema reaproveita as linhas ao atualizar os filtros: desfaz as ocultações antigas e recalcula
    (raiz || document).querySelectorAll('[data-lb-oculto]').forEach(function (li) { li.hidden = false; li.removeAttribute('data-lb-oculto'); });
    (raiz || document).querySelectorAll('.facets__inputs-list').forEach(function (lista) {
      var nome = (lista.getAttribute('name') || '').toLowerCase();
      if (nome.indexOf('nero') !== -1) {
        var agrupados = {};
        lista.querySelectorAll('input').forEach(function (i) { if (/^gid:/.test(i.value)) agrupados[(i.dataset.label || '').toLowerCase()] = true; });
        lista.querySelectorAll('input').forEach(function (i) {
          var bruto = (i.value || '').toLowerCase();
          var li = i.closest('li');
          if (GENERO[bruto] && agrupados[GENERO[bruto].toLowerCase()] && li && !i.checked) esconder(li);
        });
      }
      // mesma opção duas vezes (valor agrupado + valor bruto, comum na página de busca): fica a agrupada
      var vistos = {};
      lista.querySelectorAll('li').forEach(function (li) {
        var i = li.querySelector('input');
        var t = li.querySelector('.checkbox__label-text');
        if (!i || !t || li.hidden) return;
        var rotulo = (GENERO[(i.value || '').toLowerCase()] || t.textContent).trim().toLowerCase();
        var ehGrupo = /^gid:/.test(i.value);
        var anterior = vistos[rotulo];
        if (!anterior) { vistos[rotulo] = { li: li, grupo: ehGrupo, marcado: i.checked }; return; }
        // decide quem esconde: mantém o marcado; senão mantém o agrupado
        var escondeEste = anterior.marcado || (!i.checked && (anterior.grupo || !ehGrupo));
        if (escondeEste) esconder(li);
        else { esconder(anterior.li); vistos[rotulo] = { li: li, grupo: ehGrupo, marcado: i.checked }; }
      });
      lista.querySelectorAll('.checkbox__label-text').forEach(function (t) {
        var input = t.closest('li') && t.closest('li').querySelector('input');
        var texto = (input && input.dataset.label) || t.textContent.trim();
        if (nome.indexOf('nero') !== -1 && GENERO[texto.toLowerCase()]) texto = GENERO[texto.toLowerCase()];
        if (t.textContent.trim() !== texto) t.textContent = texto;
        var bolaVelha = t.parentNode.querySelector('.lb-filtro-cor');
        if (bolaVelha && bolaVelha.getAttribute('data-lb-cor') !== texto) { bolaVelha.remove(); }
        if (nome === 'cor' && !t.parentNode.querySelector('.lb-filtro-cor')) {
          var bola = document.createElement('span');
          bola.className = 'lb-filtro-cor';
          bola.setAttribute('data-lb-cor', texto);
          bola.setAttribute('aria-hidden', 'true');
          t.parentNode.insertBefore(bola, t);
        }
      });
    });
    // Marca é uma lista longa: começa fechada para Cor e Gênero aparecerem logo
    (raiz || document).querySelectorAll('.facets__inputs-list[name="Marca"]').forEach(function (lista) {
      var painel = lista.closest('details');
      if (painel && !painel.dataset.lbFechado && !lista.querySelector('input:checked')) {
        painel.dataset.lbFechado = '1';
        painel.removeAttribute('open');
      }
    });
    if (window.lbCoresPorNome && window.lbCoresPorNome.pintar) window.lbCoresPorNome.pintar(raiz || document);
  }

  ajustar(document);
  var agendado = false;
  function agendar() {
    if (agendado) return;
    agendado = true;
    setTimeout(function () { agendado = false; observador.disconnect(); ajustar(document); ligar(); }, 50);
  }
  var observador = new MutationObserver(function (m) {
    var relevante = m.some(function (x) {
      var alvo = x.target.nodeType === 1 ? x.target : x.target.parentElement;
      if (alvo && alvo.closest && alvo.closest('.facets__inputs-list')) return true;
      return [].some.call(x.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('.facets__inputs-list, .facets, facets-form-component') || n.querySelector('.facets__inputs-list')); });
    });
    if (relevante) agendar();
  });
  function ligar() { observador.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'data-label', 'checked', 'disabled'], characterData: true }); }
  ligar();
  document.addEventListener('change', function () { setTimeout(agendar, 300); setTimeout(agendar, 1200); }, true);
})();

/* Quantidade de produtos do filtro atual: o topo ("N produtos") vem do
   carregamento da página; ao filtrar sem recarregar, copia o total novo
   que a grade re-renderizada traz em [data-lb-total]. */
(function () {
  function atualizar() {
    var fonte = document.querySelector('[data-lb-total]');
    var alvo = document.querySelector('.lb-nav-col__qtd');
    if (!fonte || !alvo) return;
    var n = parseInt(fonte.getAttribute('data-lb-total'), 10);
    if (isNaN(n)) return;
    var txt = n.toLocaleString('pt-BR') + (n === 1 ? ' produto' : ' produtos');
    if (alvo.textContent !== txt) alvo.textContent = txt;
  }
  function iniciar() {
    var lista = document.querySelector('results-list');
    atualizar();
    if (!lista) return;
    var t;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(atualizar, 60); })
      .observe(lista, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();

/* Trava: página pedida além da última do filtro (ex.: "page=5" ficou no
   endereço e o filtro novo só tem 1 página) mostrava "Nenhum produto
   encontrado" com "15 produtos" no topo. Total > 0 e lista vazia com page>1
   → volta pro começo da lista, sem o page. */
(function () {
  function conferir() {
    var url = new window.URL(window.location.href);
    var pagina = parseInt(url.searchParams.get('page') || '1', 10);
    if (!(pagina > 1)) return;
    var fonte = document.querySelector('[data-lb-total]');
    var total = fonte ? parseInt(fonte.getAttribute('data-lb-total'), 10) : 0;
    if (!(total > 0)) return;
    if (document.querySelector('.product-grid__item')) return;
    url.searchParams.delete('page');
    window.location.replace(url.toString());
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', conferir); else conferir();
})();

/* Filtros de grade do Vitrine (mesmo modelo / mais de uma peça): valores na
   ordem da grade — RN, meses, idades, "2 A 3 ANOS", letras — e não na ordem
   que o Shopify devolve (M primeiro, RN no fim). */
(function () {
  var LETRAS = ['PP', 'P', 'M', 'G', 'GG', 'XG'];
  function peso(v) {
    v = (v || '').toUpperCase().trim();
    if (v === 'RN') return [0, 0];
    var m = v.match(/^(\d+)-(\d+)M$/);
    if (m) return [1, +m[1]];
    if (/^\d+(\/\d+)?$/.test(v)) return [2, parseFloat(v)];
    m = v.match(/^(\d+)\s*A\s*(\d+)/);
    if (m) return [3, +m[1]];
    var i = LETRAS.indexOf(v);
    if (i >= 0) return [4, i];
    return [5, 0];
  }
  function ordenar() {
    document.querySelectorAll('input[name^="filter.p.m.vitrine.tamanhos"]').forEach(function (inp) {
      var li = inp.closest('li'); var ul = li && li.parentElement;
      if (!ul || ul.dataset.lbGradeOrdenada === '1') return;
      var itens = Array.prototype.slice.call(ul.children);
      itens.sort(function (a, b) {
        var ia = a.querySelector('input'), ib = b.querySelector('input');
        var pa = peso(ia && ia.value), pb = peso(ib && ib.value);
        return pa[0] - pb[0] || pa[1] - pb[1];
      });
      itens.forEach(function (n) { ul.appendChild(n); });
      ul.dataset.lbGradeOrdenada = '1';
    });
  }
  function iniciar() {
    ordenar();
    var t;
    new MutationObserver(function (ms) {
      // só reage quando entra um filtro novo (filtrar re-renderiza a gaveta)
      for (var i = 0; i < ms.length; i++) for (var j = 0; j < ms[i].addedNodes.length; j++) {
        var n = ms[i].addedNodes[j];
        if (n.nodeType === 1 && n.querySelector && n.querySelector('input[name^="filter.p.m.vitrine.tamanhos"]')) {
          clearTimeout(t); t = setTimeout(ordenar, 80); return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
